import { render, staticRenderFns } from "./ProfilePictureWidget.vue?vue&type=template&id=682bf45e&"
import script from "./ProfilePictureWidget.vue?vue&type=script&lang=ts&"
export * from "./ProfilePictureWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports